(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('WorkqueueController', WorkqueueController);

  /* ngInject */
  function WorkqueueController($state, $stateParams, config, sessionService, workqueueService) {
    const vm = this;

    vm.activate = activate;
    vm.config = config;
    vm.currentPage = $stateParams.currentPage || 1;
    vm.filterChange = filterChange;
    vm.getWorkqueue = getWorkqueue;
    vm.getStaff = getStaff;
    vm.loading = false;
    vm.messageType = $stateParams.messageType || '';
    vm.messageStatus = $stateParams.messageStatus || '';
    vm.pageChange = pageChange;
    vm.search = search;
    vm.selectedStaffer = $stateParams.selectedStaffer || '';
    vm.sessionService = sessionService;
    vm.staff = [];
    vm.totalCount = 9999;
    vm.urgent = $stateParams.urgent || '';
    vm.workqueue = [];
    vm.workqueue_counts = {};

    vm.activate();

    function activate() {
      getStaff();
      getWorkqueue();
      getWorkqueueCounts();
    }

    function filterChange() {
      $state.go(
        'application.compliance_services.workqueue',
        {
          currentPage: vm.currentPage,
          messageStatus: vm.messageStatus,
          messageType: vm.messageType,
          selectedStaffer: vm.selectedStaffer,
          urgent: vm.urgent
        },
        { reload: true, inherit: false, notify: true }
      );
    }

    function getStaff() {
      workqueueService(sessionService.getAuthToken()).getStaff(response => vm.staff = response);
    }

    function getWorkqueue() {
      vm.loading = true;

      workqueueService(sessionService.getAuthToken()).query({ selected_staffer: vm.selectedStaffer, page: vm.currentPage, status: vm.messageStatus, message_type: vm.messageType, urgent: vm.urgent }, function(response) {
        vm.workqueue = response.message_threads;
        vm.totalCount = response.meta.total_count;
        vm.loading = false;
      }, function(_) {
        vm.loading = false;
      });
    }

    function getWorkqueueCounts() {
      workqueueService(sessionService.getAuthToken()).counts({}, function(response) {
        vm.workqueueCounts = response;
      });
    }

    function pageChange(newPageNumber, oldPageNumber) {
      vm.currentPage = newPageNumber;

      if (newPageNumber != oldPageNumber) {
        filterChange();
      }
    }

    function search() {
      $state.go('application.compliance_services.workqueue_search', { query: vm.query });
    }
  }
})();
